/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Warnings_Confirm_Downgrade_TitleInputs */

const es_components_upgrade_plan_modal_warnings_confirm_downgrade_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Warnings_Confirm_Downgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar degradación de plan`)
};

const en_components_upgrade_plan_modal_warnings_confirm_downgrade_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Warnings_Confirm_Downgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Plan Downgrade`)
};

/**
* | output |
* | --- |
* | "Confirm Plan Downgrade" |
*
* @param {Components_Upgrade_Plan_Modal_Warnings_Confirm_Downgrade_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_warnings_confirm_downgrade_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Warnings_Confirm_Downgrade_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Warnings_Confirm_Downgrade_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_warnings_confirm_downgrade_title(inputs)
	return en_components_upgrade_plan_modal_warnings_confirm_downgrade_title(inputs)
});
export { components_upgrade_plan_modal_warnings_confirm_downgrade_title as "components.upgrade_plan_modal.warnings.confirm_downgrade.title" }